import { Record } from 'immutable';

export interface PermissionsState {
  accountRecordings: boolean;
  accountStreaming: boolean;
  isAdmin: boolean;
  isSuperUser: boolean;
  isUser: boolean;
  viewDashboard: boolean;
  viewMeetings: boolean;
  viewProfile: boolean;
  viewRecordings: boolean;
  viewRoomSystems: boolean;
  viewSettings: boolean;
  viewStreaming: boolean;
  viewUsers: boolean;
}

export const initialState: PermissionsState = {
  accountRecordings: false,
  accountStreaming: false,
  isAdmin: false,
  isSuperUser: false,
  isUser: true,
  viewDashboard: false,
  viewMeetings: false,
  viewProfile: false,
  viewRecordings: true,
  viewRoomSystems: false,
  viewSettings: false,
  viewStreaming: false,
  viewUsers: false,
};

if (process.env.REACT_APP_IS_PRODUCTION === 'true') {
  initialState.viewProfile = false;
  initialState.viewRoomSystems = true;
  initialState.viewSettings = true;
}

export default class Permissions extends Record(initialState) {
}
